import crud from './_crud'
import { showSuccessMessage } from 'utils/messages'
import { callApi } from 'utils/api'

const actions = crud(
	'client_branch',
	'la planta del cliente',
	'las plantas del cliente'
)

const importClientsBranches = (options) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/client_branch/import_clients_branches`, {
			method: 'POST',
			headers: {
				Authorization: state.app.user.token,
			},
			body: JSON.stringify({
				options,
			}),
			successMessage: `Se agreron las plantas de clientes correctamente.`,
		})
		showSuccessMessage('Se registraron las plantas de clientes correctamente')
		return res.body
	}
}

export default { ...actions, importClientsBranches }
